(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-photo-slider"]) return;
  try {
    
  const slider = document.querySelector('[data-slider]');

  const track = slider.querySelector('[data-slider-track]');
  const prev = slider.querySelector('[data-slider-prev]');
  const next = slider.querySelector('[data-slider-next]');

  if (track) {
    prev.addEventListener('click', () => {
      next.removeAttribute('disabled');
      next.classList.remove('opacity-30');

      track.scrollTo({
        left: track.scrollLeft - track.firstElementChild.offsetWidth,
        behavior: 'smooth',
      });
    });

    next.addEventListener('click', () => {
      prev.removeAttribute('disabled');
      prev.classList.remove('opacity-30');

      track.scrollTo({
        left: track.scrollLeft + track.firstElementChild.offsetWidth,
        behavior: 'smooth',
      });
    });

    track.addEventListener('scroll', () => {
      const trackScrollWidth = track.scrollWidth;
      const trackOuterWidth = track.clientWidth;

      prev.removeAttribute('disabled');
      next.removeAttribute('disabled');
      prev.classList.remove('opacity-30');
      next.classList.remove('opacity-30');

      if (track.scrollLeft <= 0) {
        prev.setAttribute('disabled', '');
        prev.classList.add('opacity-30');
      }

      if (track.scrollLeft === trackScrollWidth - trackOuterWidth) {
        next.setAttribute('disabled', '');
        next.classList.add('opacity-30');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const setupRecommendations = () => {
    const section = document.querySelector('#product-recommendations');
    if (!section || (typeof Shopify !== 'undefined' && Shopify.designMode)) return;
    const observer = new IntersectionObserver((entries, obs) => {
      obs.unobserve(section);
      fetch(section.dataset.url)
        .then(r => r.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const rec = html.querySelector('#product-recommendations');
          if (rec && rec.innerHTML.trim().length) section.innerHTML = rec.innerHTML;
        })
        .catch(console.error);
    }, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(section);
  };

  setupRecommendations();
  document.addEventListener('shopify:section:load', setupRecommendations);

  document.addEventListener('click', (event) => {
    const tile = event.target.closest('.eg-product-card');
    if (!tile || !tile.dataset.href) return;
    if (event.target.closest('product-form')) return;
    if (event.target.closest('a')) return;
    window.location.href = tile.dataset.href;
  });

  } catch(e) { console.error(e); }
})();
})();
